import axios from "./axios";
import { setHeaders } from "./baseApi";
import { apiPaths } from "./baseApi";

/**
 * @param {string} [context] - Contexte facultatif
 * @returns {Promise<any>}
 */

// --------------------------Level-------------------------------------------------------

export const getAllLevel = async (idYear, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/level/all/${idYear}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const createLevel = async (payload, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + "/api/level/create",
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const getLevelById = async (id, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/level/getLevel/${id}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const updateLevel = async (payload, id, context) => {
  const response = await axios.put(
    apiPaths.baseUrl + `/api/level/${id}`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};
export const deleteLevel = async (id, context) => {
  const response = await axios.delete(apiPaths.baseUrl + `/api/level/${id}`, {
    headers: setHeaders(context),
  });
  return response.data;
};

// --------------------------Classroom-------------------------------------------------------

export const getAllClassroom = async (idYear, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/classroom/getAllClassrooms/${idYear}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const createClassroom = async (payload, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + "/api/classroom/createClassroom",
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const updateClassroom = async (payload, id, context) => {
  const response = await axios.put(
    apiPaths.baseUrl + `/api/classroom/updateClassroom/${id}`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const getClassroomById = async (id, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/classroom/getClassroomById/${id}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const deleteClassroom = async (id, context) => {
  const response = await axios.delete(
    apiPaths.baseUrl + `/api/classroom/deleteClassroom/${id}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// --------------------------Subject-------------------------------------------------------

export const getAllSubject = async (idYear, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/subject/getAllSubjects/${idYear}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const getSubjectById = async (id, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/subject/getSubjectById/${id}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const createSubject = async (payload, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + "/api/subject/createSubject",
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const updateSubject = async (payload, id, context) => {
  const response = await axios.put(
    apiPaths.baseUrl + `/api/subject/updateSubject/${id}`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const deleteSubject = async (id, context) => {
  const response = await axios.delete(
    apiPaths.baseUrl + `/api/subject/deleteSubject/${id}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// --------------------------Class-------------------------------------------------------
export const getAllClass = async (idYear, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/class/getAllClass/${idYear}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const getClassByLevel = async (idYear, idLevel, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/class/getAllClassByLevel/${idYear}/${idLevel}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const getClassById = async (id, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/class/getClass/${id}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const createClass = async (payload, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + "/api/class/create",
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const updateClass = async (payload, id, context) => {
  const response = await axios.put(
    apiPaths.baseUrl + `/api/class/${id}`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const deleteClass = async (id, context) => {
  const response = await axios.delete(apiPaths.baseUrl + `/api/class/${id}`, {
    headers: setHeaders(context),
  });
  return response.data;
};

// --------------------------SubjectUE-------------------------------------------------------

export const createSubjectUE = async (payload, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/subjectUE/create`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const getSubjectUEById = async (id, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/subjectUE/getSubjectUE/${id}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const getAllSubjectByUE = async (id_ue, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/subjectUE/all/${id_ue}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const updateSubjectUE = async (id_subjectUE, payload, context) => {
  const response = await axios.put(
    apiPaths.baseUrl + `/api/subjectUE/update/${id_subjectUE}`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const deleteSubjectUE = async (id_subjectUE, context) => {
  const response = await axios.delete(
    apiPaths.baseUrl + `/api/subjectUE/delete/${id_subjectUE}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// --------------------------Import/Export-------------------------------------------------------

export const importClass = async (payload, id_academicYear) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/importClass/${id_academicYear}`,
    payload,
    {
      headers: { ...setHeaders(), "Content-Type": "multipart/form-data" },
      withCredentials: setHeaders().withCredentials,
    },
  );
  return response.data;
};

export const exportClass = async (id_academicYear) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/exporte/class/${id_academicYear}`,
    {
      headers: setHeaders(),
      withCredentials: setHeaders().withCredentials,
      responseType: "blob",
    },
  );
  return response.data;
};

export const templateClass = async () => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/download/templateClass`,

    {
      headers: setHeaders(),
      withCredentials: setHeaders().withCredentials,
      responseType: "blob",
    },
  );
  return response.data;
};

// *******Subject**************
export const importSubject = async (payload, id_academicYear) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/importSubject/${id_academicYear}`,
    payload,
    {
      headers: { ...setHeaders(), "Content-Type": "multipart/form-data" },
      withCredentials: setHeaders().withCredentials,
    },
  );
  return response.data;
};

export const exportSubject = async (id_academicYear) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/exporte/subject/${id_academicYear}`,
    {
      headers: setHeaders(),
      withCredentials: setHeaders().withCredentials,
      responseType: "blob",
    },
  );
  return response.data;
};

export const templateSubject = async () => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/download/templateSubject`,

    {
      headers: setHeaders(),
      withCredentials: setHeaders().withCredentials,
      responseType: "blob",
    },
  );
  return response.data;
};

// *******Classroom**************
export const importClassroom = async (payload, id_academicYear) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/importClassroom/${id_academicYear}`,
    payload,
    {
      headers: { ...setHeaders(), "Content-Type": "multipart/form-data" },
      withCredentials: setHeaders().withCredentials,
    },
  );
  return response.data;
};

export const exportClassroom = async (id_academicYear) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/exporte/classroom/${id_academicYear}`,
    {
      headers: setHeaders(),
      withCredentials: setHeaders().withCredentials,
      responseType: "blob",
    },
  );
  return response.data;
};

export const templateClassroom = async () => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/download/templateClassroom`,

    {
      headers: setHeaders(),
      withCredentials: setHeaders().withCredentials,
      responseType: "blob",
    },
  );
  return response.data;
};
